module.exports = __webpack_public_path__ + "img/zs15.0f84b3f9.jpg";